<template>
  <div class="form-element">
    <input
      class="form-element__input -search"
      type="search"
      ref="search"
      :placeholder="placeholder"
      autocomplete="off"
      @keyup="changed"
      v-model.trim="val"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: "Ara...",
    },
  },
  data() {
    return {
      val: this.value,
    };
  },
  created() {
    setTimeout(() => {
      this.$refs["search"].focus();
    }, 200);
  },
  watch: {
    value: function (val) {
      this.val = val;
    },
  },
  methods: {
    changed: function (e) {
      this.$emit("input", e.target.value);

      return e.target.value;
    },
  },
};
</script>